
















import Vue, { PropOptions } from 'vue'
import { Client } from '@/components/client-work/client-modal.vue'

export default Vue.extend({
  props: {
    clients: Array as PropOptions<Client[]>
  },

  data() {
    return {
      items: [] as Array<{ client: Client; isSelected: boolean }>
    }
  },

  watch: {
    'clients'() {
      if (this.clients.length === 0) return
      this.items = this.clients.map((client, i) => ({
        client,
        delay: i * 100,
        isSelected: false
      }))
    }
  },

  methods: {
    open(id: number) {
      this.$emit('open-modal', id)
    },

    addTransitonDelay(el: HTMLElement) {
      el.style.transitionDelay = `${Number(el.dataset.index) * 100}ms`
    },

    removeTransitonDelay(el: HTMLElement) {
      el.style.transitionDelay = ''
    }
  }
})
